import { Color } from "src/games/shared/ColorValue";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { PhaserButtonConfig, PhaserButton } from "src/games/shared/Button";
import { GameState } from "src/games/FitFiveGame/objects/GameState";
import TranslateApi from "../../../utils/TranslateHelper";
import initializeInteractiveCursor from "../../shared/InteractiveCursorUtil";
import AudioTranslations from "src/constants/AudioTranslations";
import { numKeys } from "src/constants/KeyboardNumKeys";

export class CharacterFeedbackScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    npcArea: TiledGameObject;
    dialogArea: TiledGameObject;
    buttonArea: TiledGameObject;
    padding: number = 20;

    constructor() {
        super({
            key: "CharacterFeedbackScene" + Math.random()
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON('character_feedback', require("/src/assets/qci/maps/fitFiveGame/character_feedback.json"));

        var keys = [
            "FitFive.Phaser.NPCS.1.feedback",
            "FitFive.Phaser.NPCS.2.feedback",
            "FitFive.Phaser.NPCS.3.feedback",
            "FitFive.Phaser.NPCS.4.feedback",
            "FitFive.Phaser.NPCS.5.feedback",
            "FitFive.Phaser.Okay", "FitFive.Phaser.Thanks"
        ];

        keys.forEach((key) => {
            this.load.audio(key, AudioTranslations.FindByKeyAndLanguage(key, TranslateApi.currentLanguage.code).url);
        });

    }

    create(): void {
        this.enablePictureWallSceneInput(false);
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'character_feedback' });
    }

    generateScene() {
        this.background = this.add.image(0, 0, GameState.current.currentNPC.backgroundAssetKey);
        this.background.setOrigin(0);
        this.map.getObjectLayer("Object").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "npc") {
                this.npcArea = ob;
                var npc = this.add.image(ob.x, ob.y, 'assets', GameState.current.currentNPC.assetKey);
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                this.dialogArea = ob;
                this.addDialog();
            }
            else if (ob.name.startsWith("button")) {
                this.createButton(ob);
            }
        });
    }

    addDialog(): void {
        var ob = this.dialogArea;
        var text = TranslateApi.translate(GameState.current.currentNPC.feedback);
        var dialogStyle = { padding: this.padding, fontSize: 16, fontFamily: "Roboto Mono, Arial", color: "#F8E71C" };
        let dialog = this.add.text(ob.x, ob.y, text, dialogStyle);
        dialog.setOrigin(0);
        dialog.setWordWrapWidth(ob.width - 2 * this.padding, true);
        dialog.setDepth(10);

        var outline = this.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(Color.PLANET_COLORS.get("S"));
        outline.setDisplaySize(ob.width + 10, ob.height + 10);

        let dialogBackground = this.add.image(ob.x, ob.y, "pixel");
        dialogBackground.setOrigin(0);
        dialogBackground.setTint(0x000000);
        dialogBackground.setDepth(0);
        dialogBackground.setDisplaySize(ob.width, ob.height);

        var audio = this.sound.add(GameState.current.currentNPC.feedback);
        audio.play();
    }

    createButton(ob: TiledGameObject): void {
        var config = new PhaserButtonConfig();
        config.backgroundColor = Color.KUDER_PRIMARY_BUTTON;
        config.smartSize = true;
        config.keyMapping = "keydown_RIGHT";
        var translatedText;
        if (GameState.current.currentNPC.id === 5 || GameState.current.currentNPC.id === 2) {
            var name = TranslateApi.translate(GameState.current.currentNPC.name);
            translatedText = TranslateApi.translate("FitFive.Phaser.Thanks").replace("%name%", name);
        }
        else {
            translatedText = TranslateApi.translate("common.ok");
        }
        var button = new PhaserButton(this, ob.x, ob.y, ob.width, ob.height, '1 : ' + translatedText, config);
        button.setDisplaySize(button.width, button.getIdealButtonHeight());
        button.setX(this.dialogArea.x + this.dialogArea.width / 2 - button.width / 2);
        button.on('buttonClicked', () => {
            this.responseSelected();
        });

        this.onKeydown(() => {
            this.responseSelected();
        }, numKeys[0].keyCode, numKeys[0].altKeyCode);
    }

    responseSelected(): void {
        this.sound.stopAll();
        // Return to picture wall
        GameState.current.currentNPC.picked = true;
        this.enablePictureWallSceneInput(true);
        this.scene.remove(this);
        this.scene.setVisible(true, "PictureWallScene");
        this.scene.resume("PictureWallScene");
    }

    enablePictureWallSceneInput(enabled: boolean): void {
        this.scene.get("PictureWallScene").children.list.forEach((c) => {
            if (c.input != null) {
                c.input.enabled = enabled;
            }
        });
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }
}




// WEBPACK FOOTER //
// ./src/games/FitFiveGame/scenes/CharacterFeedbackScene.ts